const validationMap = {
  requiredField(value: any): string | boolean {
    if (!value) {
      return "Required field.";
    }
    return true;
  },
};

export default validationMap;
